import { render } from "./EventAddTiktok.vue?vue&type=template&id=d399bf00"
import script from "./EventAddTiktok.vue?vue&type=script&lang=js"
export * from "./EventAddTiktok.vue?vue&type=script&lang=js"

import "./EventAddTiktok.vue?vue&type=style&index=0&id=d399bf00&lang=scss&scope=true"

import exportComponent from "/data/projects/dev_private_futurelab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__